import axios from 'axios'
import Cookies from 'js-cookie'
import { useSpinnerStore } from '@/store/spinner' // import the instance

// const url = 'https://stag.apotikhimawan.my.id/apotek-backend/api' //WEB APACHE
// const url = 'http://localhost/apotekhimawan/backend/api' //WEB APACHE
// const baseUrl = 'http://localhost/apotekhimawan/backend' //WEB APACHE
// const url = 'http://localhost/apotekhimawan/backend/api' //WEB APACHE
// const baseUrl = 'http://localhost/apotekhimawan/backend/' // PHP LIVE SERVER
const url = 'https://apotekhimawan.my.id/backend/api' //WEB APACHE
const baseUrl = 'https://apotekhimawan.my.id/backend/' // PHP LIVE SERVER

const token =
    Cookies.get('user') != undefined
        ? JSON.parse(Cookies.get('user')).token
        : ''

const http = axios.create({
    baseURL: url,
    headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json',
    },
    withCredentials: true,
})

http.interceptors.request.use(
    (x) => {
        // to avoid overwriting if another interceptor
        // already defined the same object (meta)
        useSpinnerStore().loading(true)

        return x
    },
    (error) => {
        useSpinnerStore().loading(false)
        return Promise.reject(error.message)
    },
)

http.interceptors.response.use(
    (x) => {
        useSpinnerStore().loading(false)
        return x
    },
    (error) => {
        if (error.response.status === 401) {
            Cookies.remove('user')
            window.location.reload()
        }
        useSpinnerStore().loading(false)
        return Promise.reject(error)
    },
)

export { http, url, baseUrl }
